import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { EndSessionDatePicker } from '../AdminDatePicker/EndSessionDatePicker';
import { StartSessionDatePicker } from '../AdminDatePicker/StartSessionDatePicker';
import './styles.scss';
import UpdateSessionDates from '../../mutations/UpdateSessionDates';
import moment from 'moment';

type PossibleDate = Date | null;

interface ASDDatePickersProps{
	sessionID: string;
	onChange: (...args: any) => void;
	startDate: PossibleDate;
	endDate: PossibleDate;
}

interface ASDDatePickersState{
	startDate: PossibleDate;	
	endDate: PossibleDate;	
}


class AdminSessionsDetailsDatePickers extends Component<ASDDatePickersProps, ASDDatePickersState> {
	constructor(props: ASDDatePickersProps){
		super(props);
		this.state = {
			startDate: null,
			endDate: null,
		}
	}
	
	componentDidMount(){
		const { startDate, endDate } = this.props;
		this.setState({
			startDate: new Date(Number(startDate)),
			endDate: new Date(Number(endDate))
		})
	}
	
	_onChange(){
		this.props.onChange({
			variables: {
			sessionID: this.props.sessionID,
			startDate: this.state.startDate, 
			endDate: this.state.endDate
			}
		})
	}
	
	
	
	onStartDateChange(date:PossibleDate){
		this.setState({
			...this.state,
			startDate: date
		}, () => this._onChange() 
		)
		
	}
	
	onEndDateChange(date: PossibleDate) {
		this.setState({
			...this.state,
			endDate: date
		}, () => this._onChange() 
		)
	}
	

	render() {

		return (
			<div className="AdminSessionDatePickers">
				<StartSessionDatePicker 
					value={this.state.startDate} 
					onChange={(startDate) => (
						this.onStartDateChange(startDate)
					)}
				/>
				<EndSessionDatePicker 
					value={this.state.endDate}
					onChange={(endDate) => (
						this.onEndDateChange(endDate)
					)}
				/>
			</div>
		);
	}
}

export default AdminSessionsDetailsDatePickers;